<template>
  <layout-card-wrap
    v-loading="loading"
    hasSlot>
    <template slot="title">前十品牌</template>
    <div slot="form">
      <category-select v-model="config.categoryId" />
      <el-button
        style="margin-left:10px;"
        type="primary"
        @click="fetchList">查询</el-button>
    </div>
    <v-chart
      class="chart"
      :options="line" />
  </layout-card-wrap>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import Ai from '@/service/ai'
import CategorySelect from '@/pages/appraisal/order/category-select.vue'
export default {
  name: 'TopBrandData',
  components: { 'v-chart': ECharts, CategorySelect },
  props: {
    option: { type: Object, default() { return {} } }
  },
  data() {
    return {
      config: { categoryId: null },
      loading: true,
      line: {
        title: {
          text: '前10品牌库存数据'
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '2%',
          right: '2%',
          bottom: '1%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLabel: { rotate: 30 },
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: [
          { name: '库存数量', type: 'bar', data: [] }
        ]
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      this.loading = true
      Ai.gettopblandinventorys({ ...this.option, ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, data } = res.data
          console.log(result, message)
          this.line.xAxis.data = data.map(item => ({
            value: item.blandName
          }))
          this.line.series[0].data = data.map(item => item.totalStockBalance)
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
<style lang="stylus" scoped>
.chart {
    width 100%;
    height: 300px;
}
</style>
